<mat-tree
  *ngIf="dataSource?.data?.length > 0; else noData"
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  class="cbre-tree"
>
  <mat-tree-node
    *matTreeNodeDef="let node"
    matTreeNodePadding
    class="parent-node"
    [style.padding-left.px]="paddingMap[node.level] || 0"
    [ngClass]="{ highlight: node?.id === currentRecordId }"
  >
    <li class="mat-tree-node no-child" *ngIf="node.name !== 'Show More'; else showMore">
      {{ node.name }}
    </li>
    <ng-template #showMore>
      <li class="mat-tree-node no-child">
        <a class="show-more" href="javascript:void(0)" (click)="onShowMoreClick(node, $event)">
          {{ node.name }}
          <span class="loader" *ngIf="isNodeLoading(node)">
            <mat-spinner diameter="20"></mat-spinner>
          </span>
        </a>
      </li>
    </ng-template>
  </mat-tree-node>

  <mat-tree-node
    *matTreeNodeDef="let node; when: hasChild"
    matTreeNodePadding
    class="parent-node"
    [style.padding-left.px]="paddingMap[node.level] || 0"
    [ngClass]="{ highlight: node?.id === currentRecordId }"
    (click)="onNodeToggle(node, $event)"
  >
    <li>
      <div class="mat-tree-node">
        <mat-icon class="caret" [attr.aria-label]="'toggle ' + node.name">
          {{ treeControl.isExpanded(node) ? 'arrow_drop_up' : 'arrow_drop_down' }}
        </mat-icon>

        {{ node.name }}
      </div>
    </li>
  </mat-tree-node>
</mat-tree>

<ng-template #noData>
  <div class="no-data-found">No data found</div>
</ng-template>
